import React, { useEffect, useState } from "react"
import Input from "../Input/Input"
import { addBankPayment, addBankPaymentByLink } from "../../features/payment/paymentSlice"
import { showSnackBar } from "../Snackbar/Snackbar"
import { useDispatch } from "react-redux"
import { clearAlphaNumeric, clearNumber } from "../../utils/payment"

const PaymentBankViewTab = ({
                              updList,
                              address,
                              triggerUpd,
                              onClose,
                              userId,
                              onSuccessFunc,
                              onNextStep,
                              setFields,
                              setErrors,
                              isLink = true,
                              removeOld = false,
                              // WS 1406230 — the scoped onboarding-link token, present only when
                              // this tab is rendered on the public /bank-account page from a
                              // tokenised invitation. Null everywhere inside the CRM, which keeps
                              // every authenticated call site on exactly the request it sends today.
                              linkToken = null,
                              onSaving,
                            }) => {
  const dispatch = useDispatch()

  const [bankData, setBankData] = useState({
    bankName: "",
    nameOnAccount: "",
    routingNumber: "",
    accountNumber: ""
  })

  const handleInputChange = ({ target, field }) => {
    let value = target.value
    let type = target.name

    let maxLength
    if (value) {
      setErrors && setErrors((prevErrors) => ({
        ...prevErrors,
        [field]: false,
      }))
    }

    switch (type) {
      case 'routingNumber':
        maxLength = 9
        setBankData({ ...bankData, [target.name]: clearNumber(value)?.slice(0, maxLength) })
        setFields && setFields((prev) => ({ ...prev, [target.name]: clearNumber(value)?.slice(0, maxLength) }))
        break
      case 'accountNumber':
        maxLength = 17
        const formatedValue = clearAlphaNumeric(value)?.slice(0, maxLength)
        setBankData({ ...bankData, [target.name]: formatedValue })
        setFields && setFields((prev) => ({ ...prev, [target.name]: formatedValue }))
        break
      default:
        setBankData({ ...bankData, [target.name]: value })
        setFields && setFields((prev) => ({ ...prev, [target.name]: target.value }))
        break
    }
  }

  useEffect(() => {
    setBankData({ ...bankData, ...address })
  }, [address])

  const fetchData = async () => {
    let started = false
    let saved = false
    try {
      if (!bankData?.bankName || !bankData?.nameOnAccount || !bankData?.routingNumber || !bankData?.accountNumber) {
        return
      }
      started = true
      onSaving && onSaving(true)
      const response = isLink ?
        await dispatch(addBankPaymentByLink({
          ...bankData,
          userId,
          removeOld,
          linkToken,
        })) : await dispatch(addBankPayment({ ...bankData, userId, isPrimary: false }))

      if (response?.meta?.requestStatus !== 'fulfilled') {
        const message = typeof response?.payload === 'string'
          ? response.payload
          : (response?.payload?.message || 'Failed to save bank account. Please try again.')
        showSnackBar("error", message)
      } else {
        showSnackBar("success", "Bank account added successfully")
        onNextStep && onNextStep()
        onSuccessFunc && onSuccessFunc()
        updList && updList()
        onClose && onClose(false)
        saved = true
      }

    } catch (error) {
      showSnackBar("error", error)
      console.error('An unexpected error occurred while add payment card:', error)
    } finally {
      started && onSaving && onSaving(false, saved)
    }
  }
  useEffect(() => {
    if (triggerUpd) {
      fetchData()
    }
  }, [triggerUpd])

  return (
    <div className="w-full">
      <div>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">

          <Input
            label="Bank Name"
            value={bankData.bankName}
            type="text"
            name="bankName"
            className="form-control"
            placeholder="e.g. Bank of America"
            required
            onChange={(event) => handleInputChange({ target: event.target, field: "bankName" })}
          />
          <Input
            label="Name of Bank Account"
            value={bankData.nameOnAccount}
            type="text"
            name="nameOnAccount"
            className="form-control"
            placeholder="e.g. James or Company Name"
            required
            onChange={(event) => handleInputChange({ target: event.target, field: "nameOnAccount" })}
          />
          <Input
            label="Routing Number (9 digits)"
            value={bankData.routingNumber}
            type="tel"
            name="routingNumber"
            className="form-control"
            placeholder="Routing Number"
            required
            onChange={(event) => handleInputChange({ target: event.target, field: "routingNumber" })}
          />
          <Input
            label="Account Number (8 to 17 characters)"
            value={bankData.accountNumber}
            type="text"
            name="accountNumber"
            className="form-control"
            placeholder="Enter Account Number"
            required
            onChange={(event) => handleInputChange({ target: event.target, field: "accountNumber" })}
          />
        </div>
      </div>
    </div>
  )
}
export default PaymentBankViewTab
